import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000';

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

/**
 * POST /api/v1/auth/login
 * OAuth2 password flow — MUST be form-urlencoded, NOT JSON
 */
export async function loginEndpoint(email: string, password: string): Promise<LoginResponse> {
  const params = new URLSearchParams();
  params.append('username', email);
  params.append('password', password);

  const { data } = await axios.post<LoginResponse>(`${API_BASE}/api/v1/auth/login`, params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
  return data;
}
